import { Box } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { PANCAKE_LP_USDT_STM,getWeb3,TOKEN_ABI} from "../web/util.js";
import { PieChart } from "react-minimal-pie-chart";
import Web3 from 'web3';

const ProvideContainer = () => {
  let curWeb = getWeb3();
  if(!window.web3Con){
    let web3Con = new Web3(curWeb);
    window.web3Con = web3Con;
  }
  let LPContract = new window.web3Con.eth.Contract(TOKEN_ABI, PANCAKE_LP_USDT_STM);
  const [publicAddress, setPublicAddress] = useState("");
  const [ratio, setRatio] = useState(0);

  useEffect(() => {
    initBalance();
  }, [curWeb]);

  const getTotalSupplyOfPoolToken = async () => {
    let LPTotalSupply = await LPContract.methods.totalSupply().call();
    let LP = window.web3Con.utils.toBN(LPTotalSupply);
    return LP;
  }

  const getBalanceOfPoolToken = async (curAddr) => {
    let LPBalance = await LPContract.methods.balanceOf(curAddr).call();
    let LP = window.web3Con.utils.toBN(LPBalance);
    return LP;
  }

  const initBalance = async () => {
    //console.log("INIT",curWeb);
    if (curWeb) {
      let accounts = await window.web3Con.eth.getAccounts();
      if(accounts.length){
        let curAddr = accounts[0];
        setPublicAddress(curAddr);
        let totalPool = await getTotalSupplyOfPoolToken();
        let myPool = await getBalanceOfPoolToken(curAddr);
        let percent = myPool.muln(1000000).div(totalPool);
        setRatio(percent.toNumber()/1000000);
      }
    } else
      setRatio(0);
  };

  return (
    <>
      <Box className="pool-dt Minimize-dt" display="flex" flexDirection="row" alignItems="flex-end" alignContent="center">
        <h3>
          Total Liquidity
          <span style={{opacity:100}}></span>
        </h3>
        <PieChart
          style={{
            fontSize: "8px",
            width: "50%"
          }}
          labelStyle={{ fill: "#000000" }}
          lineWidth={15}
          data={[
            { title: "Your liquidity", value: (ratio *100).toFixed(6) * 1000000, color: "#FCD535" },
            { title: "Other", value: ((1-ratio) *100).toFixed(6) * 1000000, color: "#F6F7F8" }
          ]} />

        <h3 style={{ opacity:100 }}>
          Your Share<span style={{opacity:100}}>{(ratio * 100).toFixed(3)} %</span>
        </h3>
      </Box>
    </>
  );
};

export default ProvideContainer;